import script from "./VideoPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoPop.vue?vue&type=script&setup=true&lang=ts"

import "./VideoPop.vue?vue&type=style&index=0&id=95f3bcd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95f3bcd8"]])

export default __exports__